import { useCallback, useRef } from "react";

import { twMerge } from "tailwind-merge";

import { faTimesCircle } from "@fortawesome/free-solid-svg-icons/faTimesCircle";

import FontAwesomeIcon from "components/FontAwesomeIcon";

const Input = ({
  className,
  value,
  onChange,
  inputClassName,
  ...props
}: React.DetailedHTMLProps<
  React.InputHTMLAttributes<HTMLInputElement>,
  HTMLInputElement
> & { inputClassName?: string }) => {
  const inputRef = useRef<HTMLInputElement>(null);

  const hasValue = (value as string)?.length > 1;

  const clearValue = useCallback(() => {
    if (inputRef.current) {
      inputRef.current.value = "";
      onChange?.({ target: inputRef.current } as any);
    }
  }, []);

  return (
    <span className={twMerge(className, "relative")}>
      <input
        className={inputClassName}
        ref={inputRef}
        onChange={onChange}
        value={value}
        {...props}
      />
      {hasValue && (
        <FontAwesomeIcon
          icon={faTimesCircle}
          className="hidden absolute right-0 !left-auto top-[5px] cursor-pointer hover:!text-bearish-red"
          onClick={clearValue}
        />
      )}
    </span>
  );
};

export default Input;
